module.exports = __webpack_public_path__ + "img/process@8x.446c9332.png";